import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { paymentState as _paymentState, paymentStates, defaultPagingChoices, paging, listUserGroups, inboundDeliveryStatus, emptyCellContent } from "@/js/lists.ts";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { getErrorData } from "@/js/forms.js";
import { getFullNameUser, getFullNameUserHtml, userGroupName } from "@/js/user/user.js";
import Paging from "@/components/paging/PagingComponent.vue";
import Index from "@/components/paging/IndexComponent.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ContextMenu from "@/components/context-menu/ContextMenu.vue";
export default {
  name: "AdminInboundDeliveryList",
  components: {
    Confirm: Confirm,
    Paging: Paging,
    Index: Index,
    ContextMenu: ContextMenu
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      isLoading: true,
      isDataLoading: false,
      headers: [{
        text: "N°",
        value: "reference",
        align: "center",
        width: "130px",
        cellClass: "text-nowrap"
      }, {
        text: "Customer",
        value: "customer",
        align: "center"
      }, {
        text: "Status",
        value: "status",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Amount",
        value: "totalAmountCurrencyIncludeShipping",
        align: "end",
        cellClass: "text-nowrap"
      }, {
        text: "Delivery address",
        value: "deliveryAddress",
        align: "start"
      }, {
        text: "Warehouse",
        value: "warehouse"
      }, {
        text: "Carrier",
        value: "carrier"
      }, {
        text: "Order Date",
        value: "validatedAt",
        align: "center"
      }, {
        text: "Delivery Date",
        value: "deliveredAt",
        align: "center"
      }, {
        text: "Due date",
        value: "dueDate",
        align: "center"
      }, {
        text: "Payment",
        value: "paymentState",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Consultant",
        value: "consultant",
        align: "center"
      }, {
        text: "Creator",
        value: "creator",
        align: "center"
      }],
      fetchInboundDeliveryToken: null,
      items: [],
      isAdvancedFilterOpened: false,
      formSearch: {
        paging: {
          limits: paging.DEFAULT,
          currentPage: 0,
          askedPage: 0
        },
        label: "",
        paymentStates: [],
        statusAllowed: [],
        customerIds: [],
        creatorId: null,
        consultantId: null
      },
      searchLabelLastUsed: null,
      searchPaymentStatesSearchLastUsed: [],
      searchCustomerIdsSearchLastUsed: [],
      searchConsultantIdLastUsed: null,
      searchCreatorIdLastUsed: null,
      listCreator: [],
      isLoadingListCreator: false,
      listConsultant: [],
      isLoadingListConsultant: false,
      listCustomer: [],
      isLoadingListCustomer: false,
      numberOfPages: 0,
      inboundDeliveryCount: null,
      pagingLimitsChoices: defaultPagingChoices,
      isCopyingToClipboard: false,
      inboundDeliveryModalShown: false,
      paymentStates: paymentStates,
      listUserGroups: listUserGroups,
      inboundDeliveryStatus: inboundDeliveryStatus,
      emptyCellContent: emptyCellContent
    };
  },
  computed: {
    isAdvancedFiltering: function isAdvancedFiltering() {
      return this.formSearch.paymentStates.length > 0 || this.formSearch.customerIds.length > 0 || this.formSearch.consultantId !== null || this.formSearch.creatorId !== null;
    },
    paymentState: function paymentState() {
      return _paymentState;
    },
    isFilteringStatus: function isFilteringStatus() {
      return this.isFilteringToFinalize || this.isFilteringToValidate || this.isFilteringToPrepare || this.isFilteringToShip || this.isFilteringInTransit || this.isFilteringDelivered || this.isFilteringCancelled;
    },
    isFilteringToFinalize: function isFilteringToFinalize() {
      var _this$formSearch$stat;
      return (_this$formSearch$stat = this.formSearch.statusAllowed) === null || _this$formSearch$stat === void 0 ? void 0 : _this$formSearch$stat.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "DRAFT";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    },
    isFilteringToValidate: function isFilteringToValidate() {
      var _this$formSearch$stat2;
      return (_this$formSearch$stat2 = this.formSearch.statusAllowed) === null || _this$formSearch$stat2 === void 0 ? void 0 : _this$formSearch$stat2.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    },
    isFilteringToPrepare: function isFilteringToPrepare() {
      var _this$formSearch$stat3;
      return (_this$formSearch$stat3 = this.formSearch.statusAllowed) === null || _this$formSearch$stat3 === void 0 ? void 0 : _this$formSearch$stat3.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "VALIDATED";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    },
    isFilteringToShip: function isFilteringToShip() {
      var _this$formSearch$stat4;
      return (_this$formSearch$stat4 = this.formSearch.statusAllowed) === null || _this$formSearch$stat4 === void 0 ? void 0 : _this$formSearch$stat4.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "IN_PREPARATION";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    },
    isFilteringInTransit: function isFilteringInTransit() {
      var _this$formSearch$stat5;
      return (_this$formSearch$stat5 = this.formSearch.statusAllowed) === null || _this$formSearch$stat5 === void 0 ? void 0 : _this$formSearch$stat5.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "DELIVERY";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    },
    isFilteringDelivered: function isFilteringDelivered() {
      var _this$formSearch$stat6;
      return (_this$formSearch$stat6 = this.formSearch.statusAllowed) === null || _this$formSearch$stat6 === void 0 ? void 0 : _this$formSearch$stat6.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "DELIVERED";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    },
    isFilteringCancelled: function isFilteringCancelled() {
      var _this$formSearch$stat7;
      return (_this$formSearch$stat7 = this.formSearch.statusAllowed) === null || _this$formSearch$stat7 === void 0 ? void 0 : _this$formSearch$stat7.some(function (x) {
        return inboundDeliveryStatus.filter(function (x) {
          return x.id == "CANCELLED";
        }).map(function (x) {
          return x.id;
        }).includes(x);
      });
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var filters, _this2$formSearch$pay, _this2$formSearch$cus;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            filters = getFilters();
            if (filters !== null && filters !== void 0 && filters.inboundDelivery) {
              _this2.formSearch = _objectSpread(_objectSpread({}, _this2.formSearch), filters.inboundDelivery);
              if (((_this2$formSearch$pay = _this2.formSearch.paymentStates) === null || _this2$formSearch$pay === void 0 ? void 0 : _this2$formSearch$pay.length) > 0 || ((_this2$formSearch$cus = _this2.formSearch.customerIds) === null || _this2$formSearch$cus === void 0 ? void 0 : _this2$formSearch$cus.length) > 0 || !!_this2.formSearch.creatorId) {
                _this2.isAdvancedFilterOpened = true;
              }
            }
            _this2.getConsultantList();
            _this2.getCustomerList();
            _context.next = 6;
            return _this2.fetchInboundDelivery();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchInboundDelivery: function fetchInboundDelivery() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$fetchInboundDe;
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  inboundDelivery: _this3.formSearch
                });
              });
              _this3.searchLabelLastUsed = _this3.formSearch.label;
              _this3.searchPaymentStatesSearchLastUsed = _this3.formSearch.paymentStates;
              _this3.searchCustomerIdsSearchLastUsed = _this3.formSearch.customerIds;
              _this3.searchCreatorIdLastUsed = _this3.formSearch.creatorId;
              _this3.searchConsultantIdLastUsed = _this3.formSearch.consultantId;
              (_this3$fetchInboundDe = _this3.fetchInboundDeliveryToken) === null || _this3$fetchInboundDe === void 0 || _this3$fetchInboundDe.cancel();
              _this3.fetchInboundDeliveryToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 12;
              return request("/v1/inbound/deliveries/all", "post", _this3.formSearch, true, "api", null, _this3.fetchInboundDeliveryToken).then(function (response) {
                window.scrollTo({
                  top: 0
                });
                _this.items = response.data.value.items.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    isExpanded: false
                  });
                });
                _this.inboundDeliveryCount = response.data.value.total_number;
                _this.numberOfPages = Math.ceil(_this.inboundDeliveryCount / +_this.formSearch.paging.limits);
                _this.formSearch.paging.currentPage = _this.formSearch.paging.askedPage + 1;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the orders.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 12:
              _this3.isLoading = false;
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    changePage: function changePage(askedPage) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(askedPage >= 0 && askedPage <= _this4.numberOfPages)) {
                _context3.next = 5;
                break;
              }
              _this4.formSearch.paging.askedPage = askedPage;
              _context3.next = 4;
              return _this4.fetchInboundDelivery();
            case 4:
              window.scrollTo(0, 0);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    search: function search() {
      var _arguments = arguments,
        _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isResetPaging;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isResetPaging = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this5.isDataLoading = true;
              if (isResetPaging) _this5.resetPaging();
              _context4.next = 5;
              return _this5.fetchInboundDelivery();
            case 5:
              _this5.isDataLoading = false;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    rowClick: function rowClick(delivery) {
      var routeData = this.deliveryDetails(delivery);
      this.$router.push(routeData);
    },
    rowClickContextMenu: function rowClickContextMenu(mouseEvent, event) {
      mouseEvent.preventDefault();
      var contextItems = [{
        type: "routerLinkBlank",
        text: "Open in a new tab",
        class: "router-link --no-hover-underlined",
        routeData: this.deliveryDetails(event.item)
      }];
      var position = {
        x: mouseEvent.x,
        y: mouseEvent.y
      };
      this.$refs.contextMenu.openMenu(event.item, contextItems, position);
    },
    deliveryDetails: function deliveryDetails(delivery) {
      return {
        name: "adminInboundDeliveryDetails",
        params: {
          id: delivery.id
        }
      };
    },
    getConsultantList: function getConsultantList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.isLoadingListConsultant = true;
              _this = _this6;
              data = {
                user_group: ["ADMIN"],
                isConsultantOrHolding: true
              };
              _context5.next = 5;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load consultant list", {
                  type: "warning"
                });
                _this.isLoadingListConsultant = false;
                throw e;
              });
            case 5:
              response = _context5.sent;
              _this6.listConsultant = _toConsumableArray(response.data.users);
              _this6.listConsultant.sort(function (a, b) {
                if (a.active !== b.active) {
                  return a.active ? -1 : 1;
                }
                return a.fullname.localeCompare(b.fullname);
              });
              _this6.listConsultant.unshift({
                id_user: 0,
                fullname: "No consultant"
              });
              _this6.isLoadingListConsultant = false;
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getCustomerList: function getCustomerList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.isLoadingListCustomer = true;
              _this = _this7;
              data = {
                user_group: ["USER", "HORECA", "WHOLESALER"],
                include_holding: true,
                include_archive: true
              };
              _context6.next = 5;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load customer list", {
                  type: "warning"
                });
                _this.isLoadingListCustomer = false;
                throw e;
              });
            case 5:
              response = _context6.sent;
              _this7.listCustomer = _toConsumableArray(response.data.users).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  labelForList: _this.fullNameUser(x)
                });
              });
              _this7.listCustomer.sort(function (a, b) {
                if (a.active && !b.active || !a.archive && b.archive) return -1;
                if (!a.active && b.active || a.archive && !b.archive) return 1;
                return a.labelForList.localeCompare(b.labelForList);
              });
              _this7.isLoadingListCustomer = false;
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fullNameUser: function fullNameUser(user) {
      var userSuffix = "";
      if (user.archive) {
        userSuffix += " (archived)";
      } else if (!user.active) {
        userSuffix += " (inactive)";
      }
      return getFullNameUser(user) + userSuffix;
    },
    clearFiltersStatus: function clearFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        statusAllowed: []
      });
      this.search(true);
    },
    fillFiltersStatus: function fillFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        statusAllowed: inboundDeliveryStatus.map(function (x) {
          return x.id;
        })
      });
      this.search(true);
    },
    changeFilterBy: function changeFilterBy() {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      this.search(true);
    },
    fastFilter: function fastFilter(type) {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      switch (type) {
        case "to_finalize":
          if (this.isFilteringToFinalize) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "DRAFT";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "DRAFT";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id === "DRAFT";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_validate":
          if (this.isFilteringToValidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_prepare":
          if (this.isFilteringToPrepare) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "VALIDATED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "VALIDATED";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id === "VALIDATED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_ship":
          if (this.isFilteringToShip) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id === "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_transit":
          if (this.isFilteringInTransit) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "DELIVERY";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "DELIVERY";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id == "DELIVERY";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "delivered":
          if (this.isFilteringDelivered) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "DELIVERED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "DELIVERED";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id === "DELIVERED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "cancelled":
          if (this.isFilteringCancelled) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: _toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "CANCELLED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              statusAllowed: [].concat(_toConsumableArray(this.formSearch.statusAllowed.filter(function (id) {
                return id !== "CANCELLED";
              })), _toConsumableArray(inboundDeliveryStatus.filter(function (x) {
                return x.id === "CANCELLED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
      }
      this.changeFilterBy();
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this8 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this8.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    getStatusClass: function getStatusClass(item) {
      if (inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "AWAITING_CUSTOMER_VALIDATION" || inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "AWAITING_VALIDATION" || inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "ADJUSTING") {
        return "neutral";
      }
      if (inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "ON_HOLD" || inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "CANCELLED") {
        return "danger";
      }
      if (inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "DELIVERED") {
        return "success";
      }
      if (inboundDeliveryStatus.find(function (x) {
        return x.status == item.status;
      }).id === "DRAFT") {
        return "warning";
      }
      return "info";
    },
    getPaymentStateClass: function getPaymentStateClass(item) {
      if (item.paymentState === _paymentState.SUCCEEDED) return "fill-success";
      if (item.paymentState === _paymentState.FAILED) return "fill-danger";
      if (item.paymentState === _paymentState.PROCESSING) return "fill-info";
      return "fill-empty";
    },
    isPaymentLate: function isPaymentLate(item) {
      return item.paymentState !== _paymentState.SUCCEEDED && item.paymentState !== _paymentState.FAILED && new Date(item.dueDate) < new Date() && Date.diffDays(new Date(item.dueDate), new Date()) > 0;
    },
    isPaymentStateLate: function isPaymentStateLate(item) {
      if ((item.user.user_group === "HORECA" || item.user.user_group === "WHOLESALER" || item.user.isHolding) && item.deliveryAddress.country.iso_2 === "US") {
        return inboundDeliveryStatus.find(function (x) {
          return x.status == item.status;
        }).id === "DELIVERED" && this.isPaymentLate(item);
      } else {
        return (inboundDeliveryStatus.find(function (x) {
          return x.status == item.status;
        }).id === "DELIVERED" || inboundDeliveryStatus.find(function (x) {
          return x.status == item.status;
        }).id === "DELIVERY") && this.isPaymentLate(item);
      }
    },
    userGroupName: userGroupName,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUserHtml: getFullNameUserHtml
  }
};